<template>
  <!-- 土地转让 -->
  <div>
    <block>
      <div id="landTransferCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>土地转让 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <el-button v-if="scope.column.property == 'handleImg'">预览</el-button>
            <el-button v-else-if="scope.column.property == 'handleDetails'">详情</el-button>
            <span v-else>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="80">
            <template #default="scope">
             <el-button type="text" @click="handleTo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
      </div>
      <el-dialog title="土地转让详情" :append-to-body="appendtobody" v-model="dialogTableVisible">
        <el-descriptions class="margin-top"  :column="2" :size="size" border>
          <el-descriptions-item :span="2">
            <template #label>宗地座落</template>
            {{companyDetail.address || '-'}}
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>宗地标识</template>
            {{companyDetail.landSign || '-'}}
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>宗地编号</template>
            {{companyDetail.landNo || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>所在行政区</template>
            {{companyDetail.adminArea || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地用途</template>
            {{companyDetail.purpose || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>原土地使用权人</template>
            <div style="width: 250px;">{{companyDetail.oldOwnerName || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>现土地使用权人</template>
            <div style="width: 250px;">{{companyDetail.newOwnerName || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地面积（公顷）</template>
            <div style="width: 250px;">{{companyDetail.acreage || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>成交日期</template>
            <div style="width: 250px;">{{companyDetail.transTime || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地使用权类型</template>
            <div style="width: 250px;">{{companyDetail.useType || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地使用年限</template>
            <div style="width: 250px;">{{companyDetail.publishDate || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地利用状况</template>
            <div style="width: 250px;">{{companyDetail.landUseStatus || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地级别</template>
            <div style="width: 250px;">{{companyDetail.level || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>转让方式</template>
            <div style="width: 250px;">{{companyDetail.transferType || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>转让价格（万元）</template>
            <div style="width: 250px;">{{companyDetail.transAmt || '-'}}</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-dialog>
    </block>
  </div>
</template>

<script>
import { forwardBG } from '@/api/forward.js'
export default {
  name: 'land-transfer-count',
  props: { companyId: String },
  data () {
    return {
      appendtobody: true,
      companyDetail: {},
      dialogTableVisible: false,
      page: {
        total: 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '宗地座落',
        property: 'address'
      }, {
        label: '土地面积（公顷）',
        property: 'acreage'
      }, {
        label: '转让价格（万元）',
        property: 'transAmt'
      }, {
        label: '土地用途',
        property: 'purpose'
      }, {
        label: '现有土地使用权人',
        property: 'newOwnerName'
      }, {
        label: '成交日期',
        property: 'transTime'
      }],
      TableData: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    handleTo (e) {
      this.dialogTableVisible = true
      const vm = this
      const data = {
        dateBackgroundUrl: '/LandTransfer/getLandTransferDetail',
        dateBackgroundRequestType: 'get',
        data: {
          ltId: e.ltId
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          res.transTime = res.transTime ? res.transTime.substring(0, 10) : '-'
          vm.companyDetail = res
          console.log(res)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/LandTransfer/getLandTransferList',
        dateBackgroundRequestType: 'get',
        data: {
          qccCompanyId: vm.companyId,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.transTime = item.transTime ? item.transTime.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
</style>
